import config from 'config';

const {
  colors: {
    palette: {
      theme: { generalStyles }
    }
  }
} = config;

const styles = {
  global: {
    html: {
      overflowX: 'hidden'
    },
    body: {
      fontFamily: 'main',
      lineHeight: 1.25,
      color: generalStyles.bodyTextColor,
      fontSize: 'sm',
      overflowX: 'hidden',
      WebkitTapHighlightColor: 'transparent',
      '&.no-scroll': {
        overflow: 'hidden',
        height: '100vh'
      }
    },
    main: {
      flexGrow: 1
    },
    '.image-zoom': {
      cursor: 'pointer'
    },
    '.slick-prev': {
      left: '10px',
      zIndex: 10,

      '&::before': {
        content: "''"
      }
    },
    '.slick-next': {
      right: '10px',
      '&::before': {
        content: "''"
      }
    },
    '.slick-dots': {
      cursor: 'default',
      background: 'none',
      width: '100%',
      display: 'flex !important',
      marginTop: '16px',
      position: 'initial',
      overflowX: 'scroll',
      gap: '8px',

      '&::-webkit-scrollbar': {
        display: 'none'
        // width: '2px',
        // height: '4px',

        // '&-track': {
        //   width: '4px'
        // },
        // '&-thumb': {
        //   background: generalStyles.scrollColor,
        //   borderRadius: '24px'
        // }
      },

      '&.slick-mobile li': {
        width: '80px',
        height: '80px',
        div: {
          width: '80px',
          height: '80px'
        }
      },
      '&.slick-desktop li': {
        width: '120px',
        height: '120px',
        div: {
          width: '120px',
          height: '120px'
        }
      },

      li: {
        margin: 0,
        '&.slick-active >div': {
          border: '1px solid grey'
        },

        div: {
          minHeight: 'auto',
          overflow: 'hidden',
          borderRadius: '4px',
          boxSizing: 'border-box'
        }
      }
    },
    '.date-picker-field .react-datepicker': {
      '.react-datepicker__current-month': {
        display: 'none'
      },
      '.react-datepicker__header': {
        bg: generalStyles.datePickerHeader
      },
      '.react-datepicker__navigation-icon, .react-datepicker__month-read-view--down-arrow, .react-datepicker__year-read-view--down-arrow':
        {
          borderColor: generalStyles.datePickerNavIcon,
          opacity: 0.6,
          '&::after, &::before': {
            borderColor: generalStyles.datePickerNavIcon
          }
        },
      '.react-datepicker__month-read-view, .react-datepicker__year-read-view': {
        visibility: 'visible !important'
      },
      '.react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow':
        {
          top: '6px !important',
          right: '-18px',
          width: 0,
          height: 0,
          border: '6px solid transparent',
          borderTop: 0,
          borderBottom: `6px solid ${generalStyles.datePickerNavIcon}`,
          transform: 'rotate(-180deg)'
        },
      '.react-datepicker__month-dropdown ~ .react-datepicker__month-read-view, .react-datepicker__year-dropdown ~ .react-datepicker__year-read-view':
        {
          pointerEvents: 'none',
          span: {
            transform: 'scale(-1) rotate(180deg)',
            top: '5px !important'
          }
        },
      '.react-datepicker__month-read-view--selected-month, .react-datepicker__year-read-view--selected-year':
        {
          fontWeight: 700
        },
      '.react-datepicker__day[aria-disabled="false"]:not(.react-datepicker__day--keyboard-selected)':
        {
          '&:hover': {
            bg: generalStyles.datePickerDayHoverBg
          }
        },
      '.react-datepicker__day--keyboard-selected': {
        bg: generalStyles.datePickerKeyboardSelectedBg,
        '&:hover': {
          bg: generalStyles.datePickerKeyboardSelectedHoverBg
        }
      },
      '.react-datepicker__day--selected': {
        backgroundColor: generalStyles.datePickerSelectedDayBg,
        color: generalStyles.datePickerSelectedDayColor
      }
    },
    '.full-width .react-datepicker': {
      border: 'none',
      bg: 'transparent',
      width: '100%',
      display: 'block',

      '.react-datepicker__header': {
        backgroundColor: 'transparent',
        borderColor: generalStyles.datePickerCurrentMonthBorderColor,

        '.react-datepicker__current-month': {
          py: '10px',
          textTransform: 'uppercase',
          color: generalStyles.datePickerCurrentMonthColor,
          fontWeight: '700',
          fontSize: '16px',
          borderWidth: '1px 0',
          letterSpacing: '0.8px',
          '@media (min-width: 768px)': {
            py: '20px'
          }
        }
      },

      '.react-datepicker__navigation': {
        top: '17px',
        '@media (min-width: 768px)': {
          top: '25px'
        },
        'span::before': {
          borderColor: generalStyles.datePickerNavArrowColor,
          borderWidth: '2px 2px 0 0',
          width: '7px',
          height: '7px'
        }
      },

      '.react-datepicker__month-container': {
        float: 'none',
        width: '100%',

        '*': {
          fontFamily: 'main'
        },

        '.react-datepicker__day-names': {
          display: 'flex',
          justifyContent: 'space-between',
          py: '5px',

          '.react-datepicker__day-name': {
            color: generalStyles.datePickerSelectedDayName,
            fontSize: '16px',
            textTransform: 'uppercase'
          }
        },

        '.react-datepicker__month': {
          display: 'flex',
          flexDirection: 'column',
          margin: '16px 0',
          gap: '11px',
          '@media (min-width: 768px)': {
            gap: '18px'
          },

          '.react-datepicker__week': {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',

            '.react-datepicker__day': {
              position: 'relative',
              fontSize: '18px',
              color: generalStyles.datePickerDayColor,
              backgroundColor: generalStyles.datePickerDayBg,
              zIndex: 2,

              '&::before': {
                position: 'absolute',
                content: '""',
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                zIndex: -1,
                transition: 'all 0.2s'
              },

              '&[aria-selected=true]': {
                color: generalStyles.datePickerSelectedDayColor,
                fontWeight: '700',
                '&::before': {
                  backgroundColor: generalStyles.datePickerSelectedDayBeforeBg
                }
              },

              '&.react-datepicker__day--disabled[aria-disabled="true"]': {
                opacity: 0.2
              },

              '&:not(.react-datepicker__day--keyboard-selected, .react-datepicker__day--selected, .react-datepicker__day--disabled):hover':
                {
                  '&::before': {
                    backgroundColor: generalStyles.datePickerDayBeforeHoverBg
                  }
                },

              '&[aria-disabled="true"]': {
                opacity: generalStyles.datePickerDayDisabledOpacity
              }
            }
          }
        }
      }
    },

    '.slick-slider': {
      height: '100%',
      width: '100%',

      '.slick-list': {
        height: '100% !important'
      },

      '.slick-track': {
        height: '100%'
      },

      '.slick-slide': {
        overflow: 'hidden',
        padding: '0 2px'
      },

      '.slick-slide, .slick-slide > div, .slick-slide > div > img': {
        height: '100%'
      },

      '.slick-slide > div > img': {
        objectFit: 'cover'
      }
    },
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'scale(0.8)'
      },
      '100%': {
        opacity: 1,
        transform: 'scale(1)'
      }
    },
    '@keyframes fadeOut': {
      '100%': {
        opacity: 0,
        transform: 'scale(0.8)'
      },
      '0%': {
        opacity: 1,
        transform: 'scale(1)'
      }
    }
  }
};

export default styles;
